import { gate } from 'hub-http/gates';
export const GATES = {
  USER_SENT_REMINDER_NOTIFICATION: gate('ProductApprovals:UserSentReminderNotification'),
  APPROVAL_DASHBOARD: gate('ProductApprovals::Dashboard'),
  GO_TO_MARKETING_STUDIO: gate('GoToMarketingStudio'),
  REQUEST_CHANGES: gate('ProductApprovals:RequestChanges')
};